import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { cartConstants } from 'services/redux/cart/constants'
import HelperString from 'utils/helper-string'
import _ from 'lodash'
import TextDivider from 'components/atoms/TextDivider'
import { dataConstants } from 'services/redux/data/constants'
import HelperCart from 'utils/helper-cart'
import EmployeeCard, { EmployeeCardShowBasic, EmployeeCardShowDefault } from 'components/molecules/EmployeeCard'
import EmployeeExternal from 'scenes/home/book/_functions/EmployeeExternal'
import i18n from 'utils/i18n'
import { IconSystemConstants } from 'utils/constants/IconNameConstants'

import ThemedBlock from 'components/atoms/ThemedBlock'
import EmployeeInternal from 'scenes/home/book/_functions/EmployeeInternal'
import ExtendingFooter from 'scenes/home/book/_components/ExtendingFooter'
import Button from 'theme/Button'
import { employeeConstants } from 'utils/constants/employee-constants'

import { TESTID } from '_shared/config/testID'
import HelperTestID from 'utils/HelperTestID'

const EmployeeFooter = ({ submitLabel = null, onPressSubmit, showSubmitButton = true, showEmployees = true, onHeight } ) => {
	
	const [ popupExtended, setPopupExtended ] = useState( false );
	const [ lastAddedEmployee, setLastAddedEmployee ] = useState( null );
	const [ lastAddedEmployeeKind, setLastAddedEmployeeKind ] = useState( null );
	
	const _cartBookingExternalPersons = useSelector( state => {
		return state.cart[cartConstants.BOOKING_EXTERNAL_PERSONS];
	} );
	const _cartBookingCoworkers = useSelector( state => {
		return state.cart[cartConstants.BOOKING_COWORKERS];
	} );
	const _employee = useSelector( state => {
		return state.data[dataConstants.EMPLOYEE];
	} )
	
	useEffect( () => {
		if ( HelperCart.getCoworkerCount() === 0 ) {
			setPopupExtended( false );
		}
	}, [ _employee, _cartBookingExternalPersons, _cartBookingCoworkers ] );
	
	useEffect( () => {
		if( !_.isEmpty( _cartBookingExternalPersons ) ){
			setLastAddedEmployeeKind( employeeConstants.KIND_EXTERNAL );
			setLastAddedEmployee( _cartBookingExternalPersons[ _.last( Object.keys( _cartBookingExternalPersons ) ) ] );
		}else if( !_.isEmpty( _cartBookingCoworkers ) ){
			setLastAddedEmployeeKind( employeeConstants.KIND_INTERNAL );
			setLastAddedEmployee( _cartBookingCoworkers[ _.last( Object.keys( _cartBookingCoworkers ) ) ] );
		
		}else{
			setLastAddedEmployee( null );
		}
	}, [ _cartBookingExternalPersons ] );
	
	useEffect( () => {
		if ( !_.isEmpty( _cartBookingCoworkers ) ) {
			setLastAddedEmployeeKind( employeeConstants.KIND_INTERNAL );
			setLastAddedEmployee( _cartBookingCoworkers[ _.last( Object.keys( _cartBookingCoworkers ) ) ] );
		} else if ( !_.isEmpty( _cartBookingExternalPersons ) ) {
			setLastAddedEmployeeKind( employeeConstants.KIND_EXTERNAL );
			setLastAddedEmployee( _cartBookingExternalPersons[ _.last( Object.keys( _cartBookingExternalPersons ) ) ] );
		} else {
			setLastAddedEmployee( null );
		}
	}, [ _cartBookingCoworkers ] );
	
	if ( HelperCart.getCoworkerCount() === 0 ) {
		onHeight( 0 );
		return null;
	}
	
	const footerItems = [];
	if( popupExtended ){
		if( !HelperCart.bookingForOthers() ){
			footerItems.push(
				<ThemedBlock shadow>
					<EmployeeCard
						employee={ _employee }
						showHeart={ false }
						show={ EmployeeCardShowDefault }
						onPress={ true }
					/>
				</ThemedBlock>
			);
		}
		
		if( _.size( _cartBookingCoworkers ) > 0 ) {
			footerItems.push(
				<TextDivider
					key={ 'coworkers' }
					text={ i18n.t( 'page.create.coworker.mode_co_workers') }
				/>
			);
			
			const employeeItems = [];
			_.forEach( _cartBookingCoworkers, ( employee ) => {
				employeeItems.push(
					<EmployeeInternal
						item={ { ...employee, ...{deletable: true } } }
						showHeart={ false }
						show={ EmployeeCardShowDefault }
					/>
				);
			});
			
			footerItems.push(
				<ThemedBlock shadow smallPadding>
					{employeeItems}
				</ThemedBlock>
			);
		}
		
		if ( _.size( _cartBookingExternalPersons ) > 0 ) {
			footerItems.push(
				<TextDivider key={ 'external_relations' }  text={ i18n.t( 'page.create.coworker.mode_external') } />
			);
			
			const employeeItems = [];
			_.forEach( _cartBookingExternalPersons, ( employee ) => {
				employeeItems.push(
					<EmployeeExternal
						item={ { ...employee, ...{deletable: true } } }
						readOnly={ true }
					/>
				);
			});
			
			footerItems.push(
				<ThemedBlock shadow smallPadding>
					{employeeItems}
				</ThemedBlock>
			);
		}
	}
	
	let lastFooterItem = null;
	if ( lastAddedEmployee !== null ) {
		if( lastAddedEmployeeKind === 'internal' ) {
			lastFooterItem = (
				<EmployeeCard
					employee={ lastAddedEmployee }
					animationOnMount={ false }
					showHeart={ false }
					show={ EmployeeCardShowBasic }
					readOnly={ true }
				/>
			)
		} else {
			lastFooterItem = (
				<EmployeeExternal
					item={ {...lastAddedEmployee, ...{readOnly: true} } }
					animationOnMount={ false }
					showEmail={ false }
					showCompany={ false }
					readOnly={ true }
				/>
			)
		}
	}
	
	const button = (
		<Button
			testID={ HelperTestID.generate( TESTID.HOME.BOOK.EMPLOYEE_FOOTER.EXTENDING_FOOTER_COLLAPSED, [ TESTID.HOME.BOOK.EMPLOYEE_FOOTER.SUFFIX_EXTENDING_FOOTER_SUBMIT_BUTTON ]) }
			
			key={ HelperString.hash('employee-footer-submit-button') }
			//disabled={ disabled }
			onPress={ onPressSubmit }>
			
			{ submitLabel }
		</Button>
	);
	
	return (
		<ExtendingFooter
			testID={ popupExtended ? TESTID.HOME.BOOK.EMPLOYEE_FOOTER.EXTENDING_FOOTER_EXTENDED : TESTID.HOME.BOOK.EMPLOYEE_FOOTER.EXTENDING_FOOTER_COLLAPSED }
			onHeight={ onHeight }
			extended={ popupExtended }
			onPressExtend={ setPopupExtended }
			button={ button }
			buttonVisible={ showSubmitButton }
			contentVisible={ showEmployees }
			content={ lastFooterItem }
			contentIcon={ IconSystemConstants.PERSONS }
			contentIconCount={ HelperCart.getCoworkerCount() }
			contentExtended={ footerItems }
		/>
	)
}

export default EmployeeFooter;
